
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config.service';

@Component({
  selector: 'app-maintenace-mode',
  standalone: false,
  templateUrl: './maintenace-mode.component.html',
  styleUrls: ['./maintenace-mode.component.scss']
})
export class MaintenaceModeComponent {
  
  maintenaceModeText: string = "";
  constructor(    
    private _appConfig: AppConfigService
  ){
    this.maintenaceModeText = _appConfig.getAppConfig().maintenaceModeText;
  }

 }
